export const RESPONSIVE_SIZES = {
  DESKTOP: 1024,
  TABLETHD: 840,
}

const ADS_INFO = {
  'div-gpt-ad-mobile': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-box': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box',
    postResultsAdUnitPath: '/3102/priceline.dart/air_fare_results_box1_test',
    adSize: [468, 60],
    1280: [300, 250],
    setTargeting: [['location', ['first']]],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-box-1': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box',
    postResultsAdUnitPath: '/3102/priceline.dart/air_fare_results_box1_test',
    adSize: [468, 60],
    1280: [300, 250],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
    maxWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-box-2': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box_2',
    postResultsAdUnitPath: '/3102/priceline.dart/air_fare_results_box2_test',
    adSize: [160, 600],
    1280: [300, 250],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-tower': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_tower',
    postResultsAdUnitPath: '/3102/priceline.dart/air_fare_results_tower_test',
    adSize: [160, 600],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1470951919306-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_bottom',
    postResultsAdUnitPath: '/3102/priceline.dart/air_accept_bottom_test',
    adSize: [728, 90],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1447089861109-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090052411-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_2',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090103302-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_3',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090172253-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_4',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1485190827857-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_300x600',
    postResultsAdUnitPath: '/3102/priceline.dart/air_fare_results_300x600_test',
    adSize: [160, 600],
    1280: [300, 600],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1572965562221-0': {
    adUnitPath: '/3102/priceline.dart/air_search_results_branded_filter',
    adSize: [210, 180],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
    maxWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1621948623733-0': {
    adUnitPath: '/3102/priceline.dart/priceline_flight_cpc_inline',
    adSize: [210, 180],
  },
  'div-gpt-ad-1672930738853-0': {
    adUnitPath: '/3102/priceline.dart/priceline_flight_inline_test',
    adSize: [210, 180],
  },
}

export { ADS_INFO }
